module.exports = __webpack_public_path__ + "static/newcrafts-60c120d0fb41ee95a41dd1e5cefb8918.png";